<template>
  <v-card>
    <v-layout>
      <v-flex class="pa-1 form-control">
        <input
          type="text"
          v-model="search"
          :placeholder="$t('Search')"
          class="mb-0"
          @input="handleSearch"
        />
      </v-flex>
      <v-flex shrink class="text-xs-right">
        <v-btn small fab flat @click="$emit('handleCloseDialog')"><v-icon>close</v-icon></v-btn>
      </v-flex>
    </v-layout>
    <v-divider />
    <v-card-text max-height="600">
      <div class="text-xs-center" v-if="loadingProduct">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>
      <template v-else-if="products.length > 0">
        <div class="text-xs-center">
          <v-pagination
            :total-visible="6"
            v-model="pageNumber"
            @input="handleChangePage"
            :length="pagelength"
          ></v-pagination>
        </div>
        <template v-for="product in products">
          <ProductItem
            :product="product"
            :exactProductIds="exactProductIds"
            :key="`product_${product.id}`"
            @handleSelectProduct="$emit('handleSelectProduct', product)"
          />
        </template>
        <div class="text-xs-center">
          <v-pagination
            :total-visible="6"
            v-model="pageNumber"
            @input="handleChangePage"
            :length="pagelength"
          ></v-pagination>
        </div>
      </template>
      <div class="text-xs-center" v-else>No product</div>
    </v-card-text>
  </v-card>
</template>

<script>
import ProductItem from './ProductItem'
import { mapGetters } from 'vuex'
import api from '@/api'
import { PAGE } from '@/constants/page.js'

export default {
  props: ['exactProductIds'],
  components: {
    ProductItem
  },
  data() {
    return {
      loadingProduct: true,
      products: [],
      searchTimeout: null,
      search: '',
      size: 25,
      offset: 0,
      pageNumber: 1,
      pageTemp: 1,
      total: 0
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    pagelength() {
      if (this.total) {
        const total = parseFloat(this.total)
        return Math.ceil(total / this.size)
      } else {
        return 1
      }
    }
  },
  async mounted() {
    await this.handleGetProducts()
  },
  methods: {
    handleChangePage(val) {
      if (this.pageTemp == val) {
        //
      } else {
        this.pageTemp = val
        this.offset = this.pageNumber * this.size - this.size
        if (this.pageNumber != 1) {
          this.offset + 1
        }
        this.handleGetProducts()
      }
    },
    handleSearch() {
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        this.pageNumber = 1
        this.offset = this.pageNumber * this.size - this.size
        if (this.pageNumber != 1) {
          this.offset + 1
        }
        this.handleGetProducts()
      }, 500)
    },
    handleGetProducts() {
      const vm = this
      return new Promise((resolve, reject) => {
        if (!vm.selectedBot) {
          reject()
        }
        let data = {
          pageid: vm.selectedBot.pageid,
          limit: vm.size,
          offset: vm.offset
        }
        if (vm.search && vm.search.trim()) data.search = vm.search.trim()

        vm.loadingProduct = true
        vm.products = []
        if (
          vm.selectedBot.useketshop == true &&
          vm.selectedBot.ketshop_api_key &&
          vm.selectedBot.ketshop_api_secret
        ) {
          data['ketshop_api_key'] = vm.selectedBot.ketshop_api_key
          data['ketshop_api_secret'] = vm.selectedBot.ketshop_api_secret
        }

        if (
          vm.selectedBot.pageid == '106855151601601' ||
          vm.selectedBot.pageid == '102052945584054'
        ) {
          data = {
            pageid: vm.selectedBot.pageid,
            limit: vm.size,
            offset: vm.offset
          }

          api.getProductsKFC(data, function (error, response) {
            if (error) {
              console.error(error)
              vm.loadingProduct = false
              resolve()
            }
            vm.total = response.total
            vm.products = response.data
            vm.loadingProduct = false
            resolve()
          })
        } else {
          api.getProducts(data, function (error, response) {
            if (error) {
              console.error(error)
              vm.loadingProduct = false
              resolve()
            }

            vm.total = response.total
            vm.products = response.productlist
            vm.loadingProduct = false
            resolve()
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/coupon/Products.vue